/**
 * Shared manager instance for route polyline rendering
 * Centralized to avoid circular dependencies
 */

import { DirectionManager } from './directionManager'

/**
 * Global direction manager instance
 * Collects all direction icons to be rendered in the postrender event.
 * Includes internal declutter manager for spatial collision detection.
 */
export const directionManager = new DirectionManager()
